export const invalidCredentialsError = 'Неверный логин или пароль';